import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import editButtonTemplate from "templates/modules/product/product_edit_button.jinja";
import Conditional from "web/react/components/conditional/conditional";
import PDPGallery from "web/react/components/pdp-gallery/pdp-gallery";
import ProductArea, { ProductAreaPropType } from "web/react/components/product-area/product-area";
import RelatedProductsSidebar, {
    RelatedProductsSidebarPropType,
} from "web/react/components/related-products-sidebar/related-products-sidebar";
import Template from "web/react/components/template/template";
import { useProductSelector } from "web/react/hooks/use-product-selector/use-product-selector";
import { useSFLPrefetch } from "web/react/hooks/use-save-for-later/use-save-for-later";
import { RelatedProductsAreaPropType } from "web/types/related-products";

const CLASSNAME_BASE = "in-stock-affiliate-product-layout";

function BEMify(...paths) {
    return CLASSNAME_BASE + "__" + paths.join("__");
}

function ProductPage({
    editButton,
    features,
    productArea,
    relatedProductsArea,
    relatedProductsSidebar,
}) {
    useSFLPrefetch(productArea.sorted_variants);

    let galleryRelatedProducts = [];
    if (relatedProductsArea && relatedProductsArea.sections.length > 0) {
        galleryRelatedProducts = relatedProductsArea.sections[0].related_products.slice(0, 4);
    }

    let [currentProduct, setCurrentProduct] = useProductSelector(productArea.sorted_variants);

    let product = productArea.products[currentProduct];

    let sortedBuyOptions = productArea.sorted_buy_options.filter((linkId) =>
        product.link_ids.includes(linkId)
    );
    let buyOption = productArea.buy_options[sortedBuyOptions[0]];
    const clickLeadUrl = buyOption.sizes[buyOption.default_size].lead_url;
    return (
        <>
            <div className={classnames(BEMify("content"), BEMify("content") + "--primary")}>
                <div className={BEMify("primary")}>
                    <article className={BEMify("info")}>
                        <div className={BEMify("info", "gallery")}>
                            <Conditional check={editButton != null} key="edit-button">
                                <Template
                                    className={classnames(
                                        BEMify("info", "gallery", "edit"),
                                        "hidden-mobile"
                                    )}
                                    template={editButtonTemplate}
                                    args={{
                                        edit_button: editButton,
                                    }}
                                />
                            </Conditional>
                            <PDPGallery
                                key={product.product_id}
                                features={features}
                                product={product}
                                designer={productArea.designer}
                                relatedProducts={galleryRelatedProducts}
                                clickLeadUrl={clickLeadUrl}
                            />
                        </div>
                        <div
                            className={classnames(BEMify("info", "details"), {
                                [BEMify("info", "details") +
                                "--description"]: features.uj_dots_inside_gallery,
                            })}
                        >
                            <ProductArea
                                productArea={productArea}
                                handleProductChange={(id) => setCurrentProduct(id)}
                                selectedVariant={currentProduct}
                                features={features}
                            />
                        </div>
                    </article>
                    <RelatedProductsSidebar
                        {...{ relatedProductsSidebar }}
                        className={BEMify("sidebar")}
                    />
                </div>
            </div>
            {/* price history etc goes here */}
        </>
    );
}

ProductPage.propTypes = {
    editButton: PropTypes.object,
    features: PropTypes.object.isRequired,
    productArea: ProductAreaPropType.isRequired,
    relatedProductsArea: RelatedProductsAreaPropType,
    relatedProductsSidebar: RelatedProductsSidebarPropType,
};

export default ProductPage;
